import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 md:grid-cols-12" }
const _hoisted_3 = { class: "md:col-span-12" }
const _hoisted_4 = { class: "rounded-lg border border-slate-200 bg-white p-4 shadow-[0_10px_26px_rgba(15,23,42,0.05)]" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-3 lg:grid-cols-[minmax(0,1fr)_auto]" }
const _hoisted_6 = { class: "flex min-w-0 items-center gap-3 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-3 py-2.5" }
const _hoisted_7 = { class: "min-w-0" }
const _hoisted_8 = { class: "truncate text-[15px] font-semibold text-slate-900" }
const _hoisted_9 = { class: "flex shrink-0 flex-wrap gap-2 lg:justify-end" }
const _hoisted_10 = { enctype: "multipart/form-data" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "md:col-span-12" }
const _hoisted_13 = { class: "flex min-w-0 items-center gap-3" }
const _hoisted_14 = { class: "min-w-0 truncate text-slate-900" }
const _hoisted_15 = { class: "flex justify-end" }
const _hoisted_16 = {
  key: 1,
  class: "rounded-lg border border-slate-200 bg-white px-4 py-8 text-center shadow-[0_10px_26px_rgba(15,23,42,0.05)]"
}
const _hoisted_17 = { id: "loading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Panel, { header: "Tải hình ảnh" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mb-4 flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 pb-3" }, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "m-0 text-[15px] font-bold text-slate-900" }, " Tập tin hình ảnh "),
                  _createElementVNode("div", { class: "mt-1 text-[13px] font-medium text-slate-500" }, " JPG, JPEG, PNG ")
                ]),
                _createElementVNode("div", { class: "flex flex-wrap gap-2 text-[13px]" }, [
                  _createElementVNode("div", { class: "inline-flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-slate-700" }, [
                    _createElementVNode("span", null, "Khung ảnh chính"),
                    _createElementVNode("strong", { class: "whitespace-nowrap text-slate-950" }, " 360 x 232 px ")
                  ]),
                  _createElementVNode("div", { class: "inline-flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 text-slate-700" }, [
                    _createElementVNode("span", null, "Ảnh thành phần"),
                    _createElementVNode("strong", { class: "whitespace-nowrap text-slate-950" }, " 50 x 50 px ")
                  ])
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700" }, [
                    _createElementVNode("i", { class: "pi pi-image" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString($setup.listFileName.length > 0
                        ? `Đã chọn ${$setup.listFileName.length} tập tin`
                        : "Chưa chọn tập tin"), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-sm text-slate-500" }, " Có thể chọn nhiều tập tin cùng lúc ", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Button, {
                    outlined: "",
                    label: "Đính kèm tập tin",
                    icon: "pi pi-paperclip",
                    onClick: $setup.triggerFilePicker,
                    disabled: $setup.loadingBar
                  }, null, 8, ["onClick", "disabled"]),
                  _createVNode(_component_Button, {
                    label: "Đăng hình",
                    icon: "pi pi-cloud-upload",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.upload())),
                    loading: $setup.loadingBar,
                    disabled: $setup.loadingBar || $setup.listFileName.length < 1
                  }, null, 8, ["loading", "disabled"])
                ])
              ])
            ]),
            _createElementVNode("form", _hoisted_10, [
              _createElementVNode("input", {
                ref: "fileInputEl",
                id: "myFile",
                type: "file",
                class: "hidden",
                accept: ".jpeg,.png,.jpg",
                name: "files",
                multiple: "multiple",
                onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.fileChange($event.target.files))),
                disabled: $setup.loadingBar
              }, null, 40, _hoisted_11)
            ])
          ]),
          _createElementVNode("section", _hoisted_12, [
            ($setup.listFileName.length > 0)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 0,
                  value: $setup.listFileName,
                  paginator: true,
                  rows: 10
                }, {
                  header: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("div", { class: "flex items-center justify-between gap-3" }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", { class: "text-[15px] font-bold text-slate-900" }, " Tập tin đã chọn "),
                        _createElementVNode("div", { class: "text-[13px] font-medium text-slate-500" }, " Kiểm tra danh sách trước khi đăng hình. ")
                      ])
                    ], -1)
                  ]))]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "nameFile",
                      header: "Tập tin",
                      sortable: ""
                    }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_13, [
                          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700" }, [
                            _createElementVNode("i", { class: "pi pi-image" })
                          ], -1)),
                          _createElementVNode("span", _hoisted_14, _toDisplayString(slotProps.data.nameFile), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Dung lượng" }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString($setup.formatFileSize(slotProps.data.value?.size)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Thao tác" }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_Button, {
                            severity: "danger",
                            label: "Xóa",
                            icon: "pi pi-trash",
                            onClick: ($event: any) => ($setup.deleteFile(slotProps.data.nameFile)),
                            class: "!min-h-[36px] px-3 py-1.5"
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("span", { class: "inline-flex h-10 w-10 items-center justify-center rounded-lg bg-slate-100 text-slate-400" }, [
                    _createElementVNode("i", { class: "pi pi-folder-open" })
                  ], -1),
                  _createElementVNode("p", { class: "mt-3 text-sm font-semibold text-slate-600" }, " Chưa có tập tin nào được chọn. ", -1)
                ]))]))
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      header: "Tải hình",
      visible: $setup.loadingBar,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (($setup.loadingBar) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, [
          _cache[9] || (_cache[9] = _createElementVNode("label", null, "Đang tải hình lên máy chủ ...", -1)),
          _createVNode(_component_ProgressBar, {
            mode: "indeterminate",
            class: "h-[0.3em]"
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}